module.exports = __webpack_public_path__ + "img/1_036.ce0c2997.jpg";